
import {TRANSTIME} from './constant';

let defaultOffset = 0;
// 设置临时canvas大小与放大后的尺寸一样
// tempCanvas.width = enlargedWidth;
// tempCanvas.height = enlargedHeight;
function drawImage({newImg,ctx,canvasDom}) {
    // 清空画布
    ctx.clearRect(0, 0, canvasDom.width, canvasDom.height);
    // 绘制新图片
    ctx.drawImage(newImg, 0, 0, canvasDom.width, canvasDom.height);
}
//获取偏移量
function getDrawImageByTime({duration,direction,canvasDom}) {
    let time2 = TRANSTIME
    const slideWidth = canvasDom.width*0.2; // 推动的宽度
    const slideHeight = canvasDom.height*0.2; // 推动的宽度
    let startOffset:any='0'
    if(direction ==='left'){
        startOffset =  (slideWidth/duration * time2).toFixed(2);
        startOffset=startOffset>slideWidth?slideWidth:startOffset
    }else if(direction === 'up'){
        startOffset =  (slideHeight/duration * time2).toFixed(2);
        startOffset=startOffset>slideHeight?slideHeight:startOffset
    }else if(direction == 'right'){
        startOffset = (slideWidth - slideWidth/duration * time2).toFixed(2);
        startOffset=startOffset<0?0:startOffset
    }else if(direction == 'down'){
        startOffset = (slideHeight - slideHeight/duration * time2).toFixed(2);
        startOffset=startOffset<0?0:startOffset
    }
    return  Number(startOffset);
   
}

export let slideCrossImage = ({ ctx, oldImgItem,newImgItem, oldImg, newImg, type, canvasDom }) => {
    const slideWidth = canvasDom.width; // 推动的宽度
    if(!newImg){
        return;
    }
    if(!oldImg){
        drawImage({newImg,ctx,canvasDom})
    }
  
    const speed = slideWidth*20/TRANSTIME; // 推动速度
    // let videoImgCanvas = document.getElementById('videoImgCanvas');
    // nextTempCanvas.style.width = preTempCanvas.style.width = videoImgCanvas.style.width 
    // nextTempCanvas.style.height = preTempCanvas.style.height = videoImgCanvas.style.height 
    // nextTempCanvas.width = preTempCanvas.width =canvasDom.width;
    // nextTempCanvas.height = preTempCanvas.height = canvasDom.height;
    let newImgDire = newImgItem.direction;
    let newImageOffset=getDrawImageByTime({direction:newImgDire,canvasDom:canvasDom,duration:newImgItem.duration})
    let offset = newImgDire==='left'? 0:slideWidth;
    // oldImageMove.joggingMove({ctx:preTempCtx,direction:oldImgDire,newImg:oldImg,duration:oldImgItem.duration,canvasDom,startOffset:defaultOffset});
    // newImgMove.joggingMove({ctx:nextTempCtx,direction:newImgDire,newImg:newImg,duration:newImgItem.duration,canvasDom});

    const animate = () => {
        ctx.clearRect(0, 0, canvasDom.width, canvasDom.height);
        if(newImgDire==='left'){
            ctx.drawImage(oldImg, type==='slidePush'? -offset-newImageOffset : -newImageOffset, -canvasDom.height*0.1, canvasDom.width*1.2 , canvasDom.height*1.2);
            ctx.drawImage(newImg, canvasDom.width- offset-newImageOffset, -canvasDom.height*0.1, canvasDom.width*1.2, canvasDom.height*1.2);
        }else{
            ctx.drawImage(oldImg, type==='slidePush'? canvasDom.width-offset-newImageOffset : -newImageOffset, -canvasDom.height*0.1, canvasDom.width*1.2, canvasDom.height*1.2);
            ctx.drawImage(newImg, - offset-newImageOffset, -canvasDom.height*0.1, canvasDom.width*1.2, canvasDom.height*1.2);
        }
        if(newImgDire==='left'){
            offset += speed;
        }else{
            offset -= speed;
        }
        if((newImgDire==='right' && offset <= 0) || (newImgDire==='left' && offset >= slideWidth)){
            // drawImage({newImg:newImg,ctx,canvasDom}); // 绘制新图片
            // let startOffset = newImgMove.getMoveData().startOffset;
            // oldImageMove.stopJoggingTimer();
            // newImgMove.stopJoggingTimer();
            joggingMove({ctx,direction:newImgDire,newImg,duration:(newImgItem.endTime-newImgItem.startTime)*1000,canvasDom,startOffset:newImageOffset})
        }else{
            setTimeout(animate,20);
        }
    }
    setTimeout(animate,20);
}
export let slideDireImage = ({ ctx, newImgItem, oldImg, newImg, type, canvasDom})=>{
    if(!newImg){
        return;
    }
    if(!oldImg){
        drawImage({newImg,ctx,canvasDom})
    }
    const slideHeight = canvasDom.height; // 推动的宽度
    const speed = slideHeight*20/TRANSTIME; // 推动速度
    let newImgDire = newImgItem.direction;
    let newImageOffset=getDrawImageByTime({direction:newImgDire,canvasDom:canvasDom,duration:newImgItem.duration})
    let offset = newImgDire =='up'? 0:slideHeight;
    const animate = ()=>{
        ctx.clearRect(0, 0, canvasDom.width, canvasDom.height);
        if(newImgDire =='up'){
            ctx.drawImage(newImg, -canvasDom.width*0.1, type=='slidePush' ? canvasDom.height-offset-newImageOffset:-newImageOffset,canvasDom.width*1.2, canvasDom.height*1.2);
            ctx.drawImage(oldImg, -canvasDom.width*0.1,  - offset-newImageOffset, canvasDom.width*1.2, canvasDom.height*1.2);
        }else{
            ctx.drawImage(newImg, -canvasDom.width*0.1, type=='slidePush' ? -offset-newImageOffset:-newImageOffset,canvasDom.width*1.2, canvasDom.height*1.2);
            ctx.drawImage(oldImg, -canvasDom.width*0.1, canvasDom.height - offset-newImageOffset, canvasDom.width*1.2, canvasDom.height*1.2);
        }
        if(newImgDire=='up'){
            offset = offset + speed;
        }else{
            offset = offset - speed;
        }
        if(offset <= 0 || offset >= slideHeight){
            // drawImage({newImg:newImg,ctx,canvasDom}); // 绘制新图片
            // let startOffset = newImgMove.getMoveData().startOffset;
            // oldImageMove.stopJoggingTimer();
            // newImgMove.stopJoggingTimer();
            joggingMove({ctx,direction:newImgDire,newImg,duration:(newImgItem.endTime-newImgItem.startTime)*1000,canvasDom,})
        }else{
            setTimeout(animate,20);
        }
    }
    setTimeout(animate,20);
}

// let fadeImage = ({duration,oldImg,newImg})=>{
//     const timer = setInterval(() => {
//         ctx.clearRect(0, 0, canvas.width, canvas.height);
//         ctx.drawImage(oldImg, 0, 0, canvas.width, canvas.height);
//         ctx.drawImage(newImg, 0, 0, canvas.width, canvas.height);
//         if(duration<=0){
//             clearInterval(timer);
//             drawImage(newImg); // 绘制新图片
//         }
//         duration--;
//     }, 16);
// }


let joggingTimer = null
let oldImg = null
export let joggingMove =({ ctx, direction, newImg, duration, canvasDom,startOffset = 0 })=>{
    const slideWidth = canvasDom.width*0.2; // 推动的宽度
    const slideHeight = canvasDom.height*0.2; // 推动的宽度
    if(!newImg){
        return;
    }
    joggingTimer&&clearTimeout(joggingTimer);
    let speed = slideWidth*20/duration; // 推动速度
    if(direction=="up"||direction=='down'){
        speed = slideHeight*20/duration;// 推动速度
    }
    let offsetObj = {
        left:0,
        right:slideWidth,
        up:0,
        down:slideHeight
    }
    console.log('joggingMovestartOffset',startOffset);
    
    let offset = startOffset||offsetObj[direction]
    const animate = () => {
        // if (oldImg !== newImg) {
        //   ctx.clearRect(0, 0, canvasDom.width, canvasDom.height);
        //   if(direction =='left'||direction =='right'){
        //     // console.log('joggingMove',offset)
        //     ctx.drawImage(newImg, - offset, -canvasDom.height*0.1, canvasDom.width*1.2, canvasDom.height*1.2);
        //   }else{
        //     ctx.drawImage(newImg, -canvasDom.width*0.1, -offset,canvasDom.width*1.2, canvasDom.height*1.2);
            
        //   }
        // } else {
        //   console.log('joggingMove-direction', direction)
        //   console.log('joggingMove-ctx', ctx)
        //   if (direction =='left'||direction =='right') {
           
        //     ctx.translate(offset, canvasDom.height*0.1)
        //   } else {
        //     ctx.translate(canvasDom.width*0.1, offset)
        //   }
        // }
        oldImg = newImg
         ctx.clearRect(0, 0, canvasDom.width, canvasDom.height);
        if(direction =='left'||direction =='right'){
          // console.log('joggingMove',offset)
          ctx.drawImage(newImg, - offset, -canvasDom.height*0.1, canvasDom.width*1.2, canvasDom.height*1.2);
        }else{
          ctx.drawImage(newImg, -canvasDom.width*0.1, -offset,canvasDom.width*1.2, canvasDom.height*1.2);
          
        }
        
        if(direction==='left'||direction=='up'){
            offset += speed;
        }else{
            offset -= speed;
        }
        const isYDirection = direction==='up'||direction==='down';
        if(offset <= 0 || (isYDirection&&offset >= slideHeight) || (!isYDirection && offset >= slideWidth)){
            joggingTimer&&clearTimeout(joggingTimer);
            joggingTimer = null
        }else{
            joggingTimer=setTimeout(animate, 20);
            // requestAnimationFrame(animate)
        }
        defaultOffset = offset
    }
    joggingTimer = setTimeout(animate,20);
    return joggingTimer
}
export function stopJoggingTimer(){
    joggingTimer&&clearTimeout(joggingTimer);
    joggingTimer = null
}
/**
 * 根据选项设置进行图片转换
 * @param options - 转换选项
 */
export function transitionsImg(options){
    // 上一张图片有转场时，左右转场走slideCrossImage，上下转场走slideDireImage
    switch (options.type) {
        case 'slideleft':
            options.type = 'slidePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideCrossImage(options)
            break;
        case 'slideright':
            options.type = 'slidePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideCrossImage(options)
            break;
        case 'slideup':
            options.type = 'slidePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideDireImage(options)
            break;
        case 'slidedown':
            options.type = 'slidePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideDireImage(options)
            break;
        case 'wipeleft':
            options.type = 'wipePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideCrossImage(options)
            break;
        case 'wiperight':
            options.type = 'wipePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideCrossImage(options)
            break;
        case 'wipedown':
            options.type = 'wipePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideDireImage(options)
            break;
        case 'wipeup':
            options.type = 'wipePush'
            joggingTimer&&clearTimeout(joggingTimer)
            slideDireImage(options)
            break;
            
        default:
            let {ctx,newImg,direction,duration,canvasDom} = options
            let param = {
                ctx: ctx,
                newImg: newImg,
                direction:direction,
                duration: duration,
                canvasDom: canvasDom
            }
            
            // console.log('options',options);
            // 上一张图片没有转场，直接进入当前图片微动
            joggingMove(param)
            // drawImage({newImg:options.newImg,ctx:options.ctx,canvasDom:options.canvasDom}); // 绘制新图片
            break;
    }
}




